
import { ArticleData } from "./types";

export const YoutubeRecommendation: ArticleData = {
  id: 103,
  slug: "youtube-recommendation-system",
  title: "Design a video ranking system for Youtube Homepage",
  author: "HelloML",
  publishDate: "May 8, 2023",
  lastUpdated: "May 8, 2025",
  category: "ML System Design",
  readTime: "12 min read",
  readCount: 10,
  likeCount: 1,
  isPremium: true,
  contentType: "markdown",
  description: "Deep dive into YouTube's recommendation system architecture.",
  tags: ["machine learning", "video recommendation", "system design"],
  contentPath: "/docs/youtube.md",
  isPreviewEnabled: true,
  featured: true,
  comingSoon: false
};
